import React from 'react';
import PriceCard from './shared/PriceCard';

const Price = () => {
  return (
    <section id="price" className="relative py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 overflow-hidden">
      {/* Éléments décoratifs */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-gradient-to-br from-primary/20 to-red-600/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-72 h-72 bg-gradient-to-tl from-red-500/20 to-primary/10 rounded-full blur-3xl"></div>
      
      <div className="relative container mx-auto px-5">
        {/* En-tête de section */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-primary to-red-600 text-white text-sm font-semibold rounded-full mb-6">
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1"></path>
            </svg>
            Nos tarifs
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Choisissez votre <span className="text-primary">formule</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            Des tarifs adaptés à tous les besoins, pour que chacun puisse pratiquer dans les meilleures conditions
          </p>
        </div>

        {/* Grille des cartes de prix */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8 max-w-7xl mx-auto">
          <PriceCard
            title="Self-Défense"
            price="120€"
            popular={false}
            info={[
              'Cours de self-défense',
              'Techniques réalistes',
              'Mercredi 19h30',
              'Hammam disponible'
            ]}
          />
          <PriceCard
            title="Formule Complète"
            price="180€"
            popular={true}
            info={[
              'Karaté + Self-défense',
              'Accès à tous les cours',
              'Lundi, jeudi, mercredi',
              'Préparation aux grades'
            ]}
          />
          <PriceCard
            title="Karaté Adulte"
            price="120€"
            popular={false}
            info={[
              'Cours de karaté',
              'Technique traditionnelle',
              'Lundi, jeudi',
              'Préparation aux grades'
            ]}
          />
          <PriceCard
            title="Karaté Enfants"
            price="120€"
            popular={true}
            info={[
              'Cours adaptés aux enfants',
              'Mercredis 18h',
              '45min (100€)',
              '1h15 (120€)'
            ]}
          />
        </div>
        
        {/* Section informations complémentaires */}
        <div className="mt-16 text-center">
          <div className="bg-white/5 backdrop-blur-sm rounded-3xl p-6 lg:p-8 border border-white/10">
            <h3 className="text-xl lg:text-2xl font-bold text-white mb-6">Informations</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 text-left">
              <div className="flex items-start space-x-3">
                <div className="w-8 h-8 bg-gradient-to-br from-primary to-red-600 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                  </svg>
                </div>
                <div>
                  <h4 className="font-semibold text-white mb-2">Licence incluse</h4>
                  <p className="text-gray-300 text-sm">Assurance et licence F.F.K.D.A comprises dans tous nos tarifs</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-3">
                <div className="w-8 h-8 bg-gradient-to-br from-primary to-red-600 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                  </svg>
                </div>
                <div>
                  <h4 className="font-semibold text-white mb-2">Cours d'essai</h4>
                  <p className="text-gray-300 text-sm">Premier cours gratuit pour découvrir</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-3 sm:col-span-2 lg:col-span-1">
                <div className="w-8 h-8 bg-gradient-to-br from-primary to-red-600 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
                  </svg>
                </div>
                <div>
                  <h4 className="font-semibold text-white mb-2">Tout âge</h4>
                  <p className="text-gray-300 text-sm">Cours adaptés pour enfants, ados et adultes</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Price;
